import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { useEventHandlers } from '../../hooks/useEventHandlers';
import { useCurrentView } from '../ArcView/ViewContext';
import { ArcReactiveProp } from './ArcReactiveProp';

function createLayer(LayerConstructor) {
  return function ArcLayer({
    onLayerCreated,
    eventHandlers,
    children,
    ...layerProps
  }) {
    const mapView = useCurrentView();
    const [layer, setLayer] = useState();
    const [layerView, setLayerView] = useState();
    useEffect(() => {
      if (!mapView)
        return;
      const layer2 = new LayerConstructor(layerProps);
      setLayer(layer2);
      mapView.map.add(layer2);
      return () => {
        mapView.map.remove(layer2);
      };
    }, [mapView]);
    useEffect(() => {
      if (!layer)
        return;
      layer.when(() => {
        onLayerCreated?.(layer);
        mapView.whenLayerView(layer).then((layerView2) => {
          setLayerView(layerView2);
        });
      });
    }, [layer, mapView, onLayerCreated]);
    useEventHandlers(layer, eventHandlers);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      layerView && children,
      layerProps && layer && Object.entries(layerProps).map(([key, val]) => /* @__PURE__ */ jsx(
        ArcReactiveProp,
        {
          accessor: layer,
          property: key,
          value: val
        },
        key
      ))
    ] });
  };
}

export { createLayer };
